import { Badge } from "../ui/badge";
import {
  isFailedImportStatus,
  TrackedOptroImport,
  unimportedSummaryParts,
} from "../../lib/optroImportJobs";
import { ImportOutcomeSummary } from "./ImportOutcomeSummary";

interface ImportTaskCardProps {
  kindLabel: string;
  tracked: TrackedOptroImport<unknown>;
  onOpen: () => void;
}

// One Optro import in Background Tasks. Clicking it reopens the import's
// progress card, running or finished.
export const ImportTaskCard = ({
  kindLabel,
  tracked,
  onOpen,
}: ImportTaskCardProps) => {
  const { items, isDone } = tracked.job;
  const imported = items.filter(
    (item) => item.status === "complete" || item.status === "no_workpaper",
  ).length;
  const failed = items.filter((item) =>
    isFailedImportStatus(item.status),
  ).length;
  const state = !isDone
    ? {
        label: "Importing",
        className: "bg-yellow-100 text-yellow-800 border-yellow-300",
      }
    : failed > 0
      ? {
          label: "Finished with failures",
          className: "bg-red-100 text-red-800 border-red-300",
        }
      : {
          label: "Completed",
          className: "bg-green-100 text-green-800 border-green-300",
        };
  const summary = [
    `${imported} of ${items.length} imported`,
    ...unimportedSummaryParts(items),
  ];

  return (
    <button
      type="button"
      onClick={onOpen}
      className="w-full rounded-lg border p-3 text-left transition-colors hover:bg-stone-50"
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-medium text-gray-900">{kindLabel}</span>
        <Badge variant="outline" className={state.className}>
          {state.label}
        </Badge>
      </div>
      <ImportOutcomeSummary items={items} text={summary.join(" · ")} />
      <div className="mt-1 text-xs text-gray-500">
        Started at {new Date(tracked.createdAt).toLocaleString()}
      </div>
    </button>
  );
};
